import vue from "vue";
const ButtonFLoating = () => import(/* webpackPrefetch: true */'./ButtonFLoating.vue')
vue.component("ButtonFLoating", ButtonFLoating);